import React from 'react';
import { motion } from 'framer-motion';
import { useProcessing } from '../../contexts/ProcessingContext';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiDownload, FiEye, FiCheck, FiRefreshCw } = FiIcons;

export default function ProcessingResults() {
  const { processedFiles, reset } = useProcessing();

  const handleDownloadAll = () => {
    // Simulate download all functionality
    console.log('Downloading all processed files...');
  };

  const handleStartNew = () => {
    reset();
  };

  return (
    <div className="space-y-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-white rounded-lg shadow-md p-8 text-center"
      >
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <SafeIcon icon={FiCheck} className="w-8 h-8 text-green-600" />
        </div>

        <h2 className="text-2xl font-semibold text-gray-900 mb-4">
          Processing Complete!
        </h2>
        
        <p className="text-gray-600 mb-8">
          {processedFiles.length} document(s) have been successfully processed with your brand styling.
        </p>

        <div className="flex justify-center space-x-4">
          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={handleDownloadAll}
            className="flex items-center px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            <SafeIcon icon={FiDownload} className="w-5 h-5 mr-2" />
            Download All
          </motion.button>

          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={handleStartNew}
            className="flex items-center px-6 py-3 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors"
          >
            <SafeIcon icon={FiRefreshCw} className="w-5 h-5 mr-2" />
            Process More Files
          </motion.button>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
        className="bg-white rounded-lg shadow-md p-6"
      >
        <h3 className="text-lg font-semibold text-gray-900 mb-4">
          Processed Files
        </h3>

        <div className="space-y-3">
          {processedFiles.map((file, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.1 }}
              className="flex items-center justify-between p-4 bg-gray-50 rounded-lg"
            >
              <div className="flex items-center">
                <SafeIcon icon={FiCheck} className="w-5 h-5 text-green-600 mr-3" />
                <div>
                  <p className="font-medium text-gray-900">{file.name}</p>
                  <p className="text-sm text-gray-500">
                    Processed with {file.brandKit} brand kit
                  </p>
                </div>
              </div>

              <div className="flex space-x-2">
                <motion.button
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.9 }}
                  className="p-2 text-gray-500 hover:text-blue-600 transition-colors"
                  title="Preview"
                >
                  <SafeIcon icon={FiEye} className="w-4 h-4" />
                </motion.button>

                <motion.button
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.9 }}
                  className="p-2 text-gray-500 hover:text-green-600 transition-colors"
                  title="Download"
                >
                  <SafeIcon icon={FiDownload} className="w-4 h-4" />
                </motion.button>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </div>
  );
}